import {FETCH_BALANCE_INFO_SUCCESS} from "../actions/BalanceActions";

const initialState = {
    balance: null
};

export default function BalanceReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_BALANCE_INFO_SUCCESS:
            return {
                ...state,
                balance: action.payload,
            };

        default:
            return state;
    }
}